import { render, staticRenderFns } from "./Whiteboard.vue?vue&type=template&id=bafbc600&scoped=true&"
import script from "./Whiteboard.vue?vue&type=script&lang=js&"
export * from "./Whiteboard.vue?vue&type=script&lang=js&"
import style0 from "./Whiteboard.vue?vue&type=style&index=0&id=bafbc600&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bafbc600",
  null
  
)

export default component.exports